import React from "react";
import { Button } from "../../button/Button";
import { ButtonRow } from "../../button/ButtonRow";
import style from "./style.scss";

export const Fullscreen = ({ title, children, onClose, onSettingsClick }) => {
    return (
        <div className={style.base}>
            <div className={style.titlebar}>
                <div className={style.title}>{title}</div>
                <div className={style.buttons}>
                    <ButtonRow>
                        {onSettingsClick ? (
                            <Button square icon="gear" iconColor="primary" onClick={onSettingsClick} />
                        ) : null}

                        <Button onClick={onClose} color="primary" square icon="close" />
                    </ButtonRow>
                </div>
            </div>
            <div className={style.content}>{children}</div>
        </div>
    );
};
